import React, { useContext, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { Contextfirst, server } from "..";
import AuthLayout from "../components/AuthLayout";

const Login = () => {
  const [isHovered, setIsHovered] = useState(false);
  const { authentication, Setauthentication } = useContext(Contextfirst);
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const handlesubmit = async (e) => {
    e.preventDefault();
    const { email, password } = data;
    setSubmitting(true);
    try {
      await axios.post(
        `${server}/users/login`,
        { email, password },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      toast.success("Logged In Successfully");
      Setauthentication(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  if (authentication) {
    return <Navigate to="/home" />;
  }

  const inputClass =
    "w-full rounded-xl border border-brand-forest/12 bg-white px-4 py-3 font-display text-[0.95rem] text-brand-forest outline-none transition placeholder:text-brand-muted/55 focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/20";

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Log in to continue your study session."
      panelTitle="Pick up where you left off."
      panelCopy="Your study tools for math, notes, and writing — ready whenever you are."
    >
      <form className="space-y-4" autoComplete="off" onSubmit={handlesubmit}>
        <div className="flex flex-col gap-1.5">
          <label
            htmlFor="login-email"
            className="font-display text-sm font-semibold text-brand-forest"
          >
            Email
          </label>
          <input
            id="login-email"
            type="email"
            required
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            placeholder="example@email.com"
            className={inputClass}
          />
        </div>

        <div className="flex flex-col gap-1.5">
          <label
            htmlFor="login-password"
            className="font-display text-sm font-semibold text-brand-forest"
          >
            Password
          </label>
          <div className="relative">
            <input
              id="login-password"
              type={showPassword ? "text" : "password"}
              required
              value={data.password}
              onChange={(e) => setData({ ...data, password: e.target.value })}
              placeholder="Enter your password"
              className={`${inputClass} pr-12`}
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-muted transition hover:text-brand-forest"
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <i
                className={`text-xl ${
                  showPassword ? "ri-eye-off-line" : "ri-eye-line"
                }`}
              />
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between gap-3 pt-0.5">
          <label className="inline-flex cursor-pointer items-center gap-2 font-display text-sm text-brand-muted">
            <input
              type="checkbox"
              id="rememberMeCheckbox"
              className="h-4 w-4 rounded border-brand-forest/30 text-brand-teal focus:ring-brand-teal"
            />
            Remember me
          </label>
          <a
            href="#/"
            className="font-display text-sm font-medium text-brand-teal-dark no-underline transition hover:text-brand-forest"
          >
            Forgot password?
          </a>
        </div>

        <button
          type="submit"
          disabled={submitting}
          className="btn mt-2 w-full disabled:cursor-not-allowed disabled:opacity-70"
        >
          {submitting ? "Logging in..." : "Log in"}
        </button>

        <Link
          to="/home"
          className="flex items-center justify-center gap-1.5 pt-1 font-display text-sm font-medium text-brand-muted no-underline transition hover:text-brand-forest"
        >
          Continue without logging in
          <i className="ri-arrow-right-line" />
        </Link>

        <p className="m-0 pt-1 text-center font-display text-sm text-brand-muted">
          Don&apos;t have an account?{" "}
          <Link
            to="/signup"
            className="font-semibold text-brand-teal-dark no-underline transition hover:text-brand-forest"
          >
            Sign up
          </Link>
        </p>

        <div className="relative py-2">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-brand-forest/10" />
          </div>
          <div className="relative flex justify-center">
            <span className="bg-brand-surface px-3 font-display text-xs uppercase tracking-[0.08em] text-brand-muted">
              Or continue with
            </span>
          </div>
        </div>

        <div className="relative grid grid-cols-2 gap-3">
          {isHovered && (
            <div className="absolute -top-9 left-1/2 z-10 -translate-x-1/2 rounded-lg bg-brand-forest px-3 py-1.5 font-display text-xs text-white shadow-brand">
              Currently unavailable
            </div>
          )}
          <button
            type="button"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-brand-forest/12 bg-white font-display text-sm font-semibold text-brand-forest transition hover:border-brand-teal/40 hover:bg-brand-soft/60"
          >
            <img
              width="20"
              height="20"
              src="https://img.icons8.com/color/512/facebook-new.png"
              alt=""
            />
            Facebook
          </button>
          <button
            type="button"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-brand-forest/12 bg-white font-display text-sm font-semibold text-brand-forest transition hover:border-brand-teal/40 hover:bg-brand-soft/60"
          >
            <img
              width="20"
              height="20"
              src="https://img.icons8.com/fluency/512/google-logo.png"
              alt=""
            />
            Google
          </button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default Login;
